// TinyMCEIntegration.tsx
// TypeScript version: TinyMCE admin editor (self-hosted) + frontend viewer with type safety

import React, {useEffect, useRef} from 'react';
import { Editor } from '@tinymce/tinymce-react';
import type { Editor as TinyMCEEditor } from 'tinymce';
// import DOMPurify from 'dompurify';

// Import TinyMCE core and plugins from local node_modules (self-hosted)
// import 'tinymce/tinymce';
// import 'tinymce/themes/silver';
// import 'tinymce/icons/default';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/image';
// import 'tinymce/plugins/link';
// import 'tinymce/plugins/table';
// import 'tinymce/plugins/lists';
// import 'tinymce/skins/ui/oxide/skin.min.css';
// import 'tinymce/skins/content/default/content.min.css';
import {FormInstance} from "antd/lib";
import {Col, Row} from "antd";
import {ProFormText} from "@ant-design/pro-components";
// import {Toolbar} from "@wangeditor/editor-for-react";

// ---------------------------
// Admin-side editor
// ---------------------------
interface AdminEditorProps {
    value: string;
    onChange: (content: string) => void;
}

interface IProps {
    name: string,
    label: string,
    value: string,
    height? :number,
    formRef: FormInstance<any>,
    required?: boolean,
    explain_error?: string
}

//export function MyTinyMCEEditor({ value, onChange }: AdminEditorProps) {
export function MyTinyMCEEditor(props: IProps) {
    const editorRef = useRef<TinyMCEEditor | null>(null);

    useEffect(() => {
    }, []);

    const onChange = (content: string) => {
        if (content === "<p><br></p>") {
            content = "";
        }
        props.formRef?.setFieldsValue({[props.name]: content});
    }

    const imageUpload = (blobInfo: any, progress: any) => new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', '/adminApi/files/upload');

        xhr.upload.onprogress = (e) => {
            progress(e.loaded / e.total * 100);
        };

        xhr.onload = () => {
            if (xhr.status === 403) {
                reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
                return;
            }

            if (xhr.status < 200 || xhr.status >= 300) {
                reject('HTTP Error: ' + xhr.status);
                return;
            }

            const json = JSON.parse(xhr.responseText);

            if (!json || typeof json.data != 'string') {
                reject('Invalid JSON: ' + xhr.responseText);
                return;
            }

            resolve(json.data);
        };

        xhr.onerror = () => {
            reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
        };

        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());

        xhr.send(formData);
    });

    return (<Col span={24}>
            <Row>
                <Col className={`editorLabel ${props.required ? 'MyItemRequired' : ''}`} span={4}>
                    {props.label}
                </Col>
                <Col span={20}>
                    <ProFormText name={props.name} hidden={true}/>
                    <div className={"editorContainer"}>
                        <Editor tinymceScriptSrc='/tinymce/tinymce.min.js'
                                onInit={(_evt, editor) => (editorRef.current = editor)}
                                initialValue={props.value}
                                init={{
                                    border: false,
                                    height: props.height || 360,
                                    minHeight: 360,
                                    menubar: false,
                                    language: 'zh_CN',
                                    plugins: 'link image code table lists',
                                    toolbar: 'undo redo blocks fontsize forecolor textStyleMenu' +
                                        ' | link image table media' +
                                        ' | Bullist numlist blockStyleMenu' +
                                        ' | removeformat code',
                                    setup: (editor) => {
                                        editor.ui.registry.addMenuButton('textStyleMenu', {
                                            icon: 'format',
                                            fetch: (callback) => {
                                                callback([
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Bold',
                                                        icon: 'Bold',
                                                        onAction: () => editor.execCommand('Bold')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Italic',
                                                        icon: 'Italic',
                                                        onAction: () => editor.execCommand('Italic')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Underline',
                                                        icon: 'Underline',
                                                        onAction: () => editor.execCommand('Underline')
                                                    }
                                                ]);
                                            }
                                        });
                                        editor.ui.registry.addMenuButton('blockStyleMenu', {
                                            icon: 'align-left',
                                            fetch: (callback) => {
                                                callback(   [
                                                    {
                                                        type: 'menuitem',
                                                        text: 'alignleft',
                                                        icon: 'align-left',
                                                        onAction: () => editor.formatter.toggle('alignleft')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'aligncenter',
                                                        icon: 'align-center',
                                                        onAction: () => editor.formatter.toggle('aligncenter')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'alignright',
                                                        icon: 'align-right',
                                                        onAction: () => editor.formatter.toggle('alignright')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'alignjustify',
                                                        icon: 'align-justify',
                                                        onAction: () => editor.formatter.toggle('alignjustify')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'outdent',
                                                        icon: 'outdent',
                                                        onAction: () => editor.execCommand('outdent')
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'indent',
                                                        icon: 'indent',
                                                        onAction: () => editor.execCommand('indent')
                                                    },
                                                ]);
                                            }
                                        });
                                    },
                                    // toolbar_mode: 'sliding',
                                    branding: false,
                                    // skin: false,
                                    content_style: `body { font-family: Arial; font-size: 14px; border: none; outline: none;}
                    table { border-collapse: collapse; width: 100%; }
                    td, th { border: 1px solid #ccc; padding: 8px; }
                    img { max-width: 100%; height: auto; }
                    `,
                                    images_upload_url: '/adminApi/files/upload',
                                    automatic_uploads: true,
                                    // @ts-ignore
                                    images_upload_handler: imageUpload
                                }}
                                onEditorChange={(content: string) => onChange(content)}
                        />
                    </div>
                </Col>
            </Row>
        </Col>
    );
}

// ---------------------------
// Front-end read-only viewer
// ---------------------------
// interface RichContentProps {
//     html: string;
// }

// export function RichContent({ html }: RichContentProps) {
//     return (
//         <div
//             className="rich-content"
//             dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) as string }}
//         />
//     );
// }

/*
// ---------------------------
// Example upload API (Node.js + Express)
// ---------------------------
const express = require('express');
const multer = require('multer');
const path = require('path');
const app = express();

const upload = multer({ dest: 'uploads/' });
app.post('/api/upload', upload.single('file'), (req, res) => {
  const fileUrl = `/uploads/${req.file.filename}`;
  res.json({ url: fileUrl });
});

// Serve static uploads
app.use('/uploads', express.static(path.join(__dirname, 'uploads')));
*/
